// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAzOEdyhGf26goGSZAadOyMMqCavLrcHpY',
    authDomain: 'four-eleven-web.firebaseapp.com',
    databaseURL:
      'https://four-eleven-web-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'four-eleven-web',
    storageBucket: 'four-eleven-web.appspot.com',
    messagingSenderId: '57116347639',
    appId: '1:57116347639:web:aa882abdac8d06226697f2',
    measurementId: 'G-SLJKJPNR5K',
  },
  cookieDomain: 'localhost',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
